/*
 *
 * TermsAndCondition constants
 *
 */

export const DEFAULT_ACTION = 'src/TermsAndCondition/DEFAULT_ACTION';
